import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { AntSelect } from "@/CommonElements/AntSelect";
import { useGroupsQuery } from "@/services/groups";

/**
 * Group options for the Users list filter modal — data from GET /api/v1/groups (system_id = user management).
 */
export const UsersListGroupFilterSelect = ({
  value,
  onChange,
  placeholder,
  allowClear = true,
}) => {
  const { t } = useTranslation();

  const { data: groupsRes, isLoading } = useGroupsQuery();

  const options = useMemo(() => {
    const rows = groupsRes?.data?.data;
    if (!Array.isArray(rows)) return [];
    return rows.map((g) => ({
      value: g.id,
      label: g.name,
    }));
  }, [groupsRes]);

  return (
    <AntSelect
      loading={isLoading}
      showSearch
      allowClear={allowClear}
      placeholder={placeholder || t("GROUP")}
      value={value ?? undefined}
      onChange={onChange}
      options={options}
      optionFilterProp="label"
      className="w-100"
    />
  );
};
